import React from "react";

import { Container, Row, Col, Button } from "reactstrap";
import Countries from "./Countries";
import S2 from "./svgs/s2";
import S3 from "./svgs/s3";
import S8 from "./svgs/s8";
import S1 from "./svgs/s1";
import ScrollAnimation from "react-animate-on-scroll";
import Slider from "react-slick";
import { size } from "./common";

function Speaker({ speakers }) {
  const content = [
    {
      title: "Banks Reimagined: The Shift from Legacy to Digital-First Financial Powerhouses:",
      description:
        "With traditional banks reimagining their operating models, fintech disruptors driving innovation, and regulatory frameworks fostering seamless digital adoption, Qatar is at the forefront of the next wave of financial evolution",
      image: <S2 />,
    },
    {
      title: "Next-Gen Banking: AI & the Future of Customer Experience",
      description:
        "With the rise of AI-powered banking, cloud-native infrastructure, and real-time analytics, Qatar’s financial sector is embracing next-generation technologies to enhance agility and customer experience. ",
      image: <S3 />,
    },
    {
      title: "A Cashless Qatar: The Future of Payments & Digital Transactions:",
      description:
        "As Qatar accelerates towards a cashless economy, real-time payments, digital wallets, and CBDCs are paving the way for a frictionless financial ecosystem. This session will explore the impact of blockchain, tokenization, and open banking APIs in shaping the future of transactions.",
      image: <S8 />,
    },
  ];
  const content1 = [
    {
      title: "Insights",
      description:
        "Finnovex Qatar 2026 is where the region’s financial visionaries converge to redefine the future. As Qatar accelerates towards its Vision 2030, this summit delivers cutting-edge insights. Attendees will gain actionable takeaways through power-packed keynotes, transformative case studies, and in-depth discussions on regulatory landscapes, embedded finance, and digital banking evolution.",
    },
    {
      title: "Networking",
      description:
        "Finnovex fosters connections that drive change. Exclusive networking opportunities, and high-impact meetings bring together financial institutions, fintech pioneers, and regulators. Engage in meaningful conversations, explore investment collaborations, and build game-changing partnerships in a dynamic setting.",
    },
    {
      title: "Spotlight",
      description:
        "Maximize your brand’s reach at Finnovex Qatar 2026. With extensive media exposure, immersive sponsor showcases, and tailored engagement sessions, this is your platform to connect with decision-makers and amplify your impact in Qatar’s thriving fintech ecosystem.",
    },
    {
      title: "Roundtables",
      description:
        "At the heart of Finnovex Qatar 2026, elite roundtable discussions bring together top-tier executives, policymakers, and industry disruptors to tackle the most pressing financial challenges. These closed-door sessions pave the way for transformative strategies, fostering resilience, innovation, and sustainable financial growth in Qatar’s rapidly evolving digital economy.",
    },
  ];

  const settings = {
    dots: true,
    autoplay: true,
    arrows: false,
    autoplaySpeed: 3000,
    swipeToSlide: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    rows: 1,
    className: "p-10",
    customPaging: function (i) {
      return <div className="dot"></div>;
    },
    dotsClass: "slick-dots slick-thumb",
  };
  return (
    <>
      <div
        style={{
          backgroundColor: "transparent",

          overflow: "hidden",
        }}
        className="section py-3"
      >
        <Container
          fluid
          style={{
            backgroundRepeat: "no-repeat",
            backgroundPosition: "top right",

            backgroundSize: "80%",
          }}
        >
          <Container className="py-2">
            <Row>
              <Col lg={11}>
                {" "}
                <span className="text-white"></span>
                <h2 className="text-400 text-white">
                  Building a Digital-First Financial Future:
                  <br /> Fintech’s Role in Qatar’s Vision 2030
                </h2>
              </Col>
            </Row>
            <Row>
              <Col lg={12} md={12} sm={12} className="">
                <h5
                  className="text-400 text-white text-justify"
                  style={{
                    lineHeight: "30px",
                    color: "#010011",
                    textTransform: "none",
                  }}
                >
                  <br />
                  <br />
                  Qatar is fast-tracking its digital finance revolution, with bold regulatory
                  reforms, fintech investments, and AI-driven innovations shaping its financial
                  future. As the nation advances toward Vision 2030, Finnovex Qatar 2026 returns as
                  the leading platform for industry pioneers, decision-makers, and disruptors to
                  drive the next wave of financial transformation. Join us on November 18 in Doha to
                  explore how open banking, digital payments, embedded finance, and cybersecurity
                  are redefining Qatar’s fintech landscape—fueling a smarter, more inclusive, and
                  future-ready economy.
                  <br />
                  <br />
                </h5>
              </Col>
              {content.map((s, index) => (
                <Col lg={6} className="mt-5 pr-0">
                  <ScrollAnimation
                    animateIn={"fadeInUp"}
                    animateOnce={true}
                    duration={0.5 + index / 8}
                  >
                    <div className="pt-4 px-2 stat-div mb-2" style={{ minHeight: 200 }}>
                      <div className="container-fluid row pr-0">
                        <Col className="align-self-center" xs={3}>
                          {s.image}
                        </Col>
                        <Col>
                          <h3
                            style={{
                              color: "#fff",
                              fontSize: size ? "18px" : "14px",
                            }}
                            className="text-700 mt-0"
                          >
                            {s.title}
                          </h3>
                          <h3
                            style={{
                              color: "#fff",
                              fontSize: size ? "16px" : "12px",
                            }}
                            className="text-400 mt-0"
                          >
                            {s.description}
                          </h3>
                        </Col>
                      </div>
                    </div>
                  </ScrollAnimation>
                </Col>
              ))}
            </Row>
          </Container>
          <Container>
            <Row>
              <Col lg={12}>
                <h3
                  style={{
                    color: "#fff",
                    fontSize: size ? "36px" : "20px",
                  }}
                  className="text-400 mt-5"
                >
                  What Makes Finnovex Unique? Shaping Qatar’s Digital Finance Revolution
                </h3>
              </Col>
            </Row>
            <Slider {...settings}>
              {content1.map((data, i) => (
                <div className="d-flex w-100 mb-5">
                  <Col lg={6} className="align-self-center">
                    <h3
                      style={{
                        color: "#fff",
                        fontSize: "36px",
                      }}
                      className="text-400 mt-0"
                    >
                      <i class="fa fa-quote-left text-primary" aria-hidden="true"></i>{" "}
                      <span className="pl-4 pr-4">{data.title}</span>
                      <i class="fa fa-quote-right text-primary" aria-hidden="true"></i>
                    </h3>
                    <h4 className="text-400 mt-0 text-white">{data.description}</h4>
                  </Col>
                  <Col lg={6}>
                    <img src={require(`assets/quotes/${i + 5}.jpg`)} width="100%" alt="main logo" />
                  </Col>
                </div>
              ))}
            </Slider>
          </Container>

          <Countries />
          <Container>
            <Row className="justify-content-center">
              <Col lg={4} className="text-center">
                <Button
                  href="/register"
                  className="btn my-2 text-center px-5"
                  color="primary"
                  size="lg"
                  outline
                >
                  Register Now
                </Button>
              </Col>
            </Row>
          </Container>
          <Container className="py-5">
            <Row className="justify-content-center">
              {images.map((id, i) => (
                <Col lg={4} xs={12} key={i}>
                  <img
                    alt="..."
                    className=" img-responsive my-3"
                    width="100%"
                    src={require(`assets/images/photos/${id}`)}
                  />
                </Col>
              ))}
            </Row>
          </Container>
        </Container>
      </div>
    </>
  );
}

export default Speaker;

const images = [
  "BO2A9941.jpg",
  "DSC_0119.jpg",
  "DSC_0154.jpg",
  "DSC_0168.jpg",
  "DSC_0178.jpg",
  "DSC_0195.jpg",
  "DSC_0332.jpg",
  "DSC_0511.jpg",
  "DSC_9715.jpg",
  "DSC_9854.jpg",
  "DSC_9885.jpg",
];
